module.exports = __webpack_public_path__ + "media/images/online_talks/decor-11bf62f8dd1dbf2608f20f3a68f66df3.png";